import React from 'react'
import { useRouter } from 'next/router'

import useTracker from './useTracker'
import OrderSuccess from './OrderSuccess'
import MembershipDetails from './MembershipDetails'

const Member = ({ data, email, track }) => {
  const { query } = useRouter()
  const { trackOrderSuccess } = useTracker({
    data,
    track,
    query,
  })

  if (query.orderSuccess) {
    return (
      <OrderSuccess
        email={email}
        query={query}
        trackOrderSuccess={trackOrderSuccess}
      />
    )
  }

  return <MembershipDetails data={data} track={track} query={query} />
}

export default Member
